import {CommonModule} from '@angular/common';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {DrawerModule} from 'primeng/drawer';
import {Subscription} from 'rxjs';
import {AppComponentDrawerComponent} from './app-component-drawer.component';
import {AppDrawerService} from './app-drawer.service';
import {DrawerEntry} from './app-drawer.types';
import {AppTemplateDrawerComponent} from './app-template-drawer.component';

@Component({
	selector: 'ngx-app-drawer-host',
	standalone: true,
	imports: [CommonModule, DrawerModule, AppTemplateDrawerComponent, AppComponentDrawerComponent],
	template: `
		<ng-container *ngFor="let entry of entries; trackBy: trackById">
			<p-drawer
				[(visible)]="entry.visible"
				position="right"
				[styleClass]="entry.styleClass"
				[style]="drawerStyle(entry)"
				appendTo="body"
				[modal]="entry.modal"
				[dismissible]="entry.dismissible"
				[closeOnEscape]="entry.closeOnEscape"
				[blockScroll]="true"
				[closable]="false"
				(visibleChange)="onDrawerVisibleChange($event, entry)"
				(onHide)="onDrawerHide(entry)"
			>
				<ng-template pTemplate="headless">
					<div class="app-dynamic-drawer__shell" [class.app-dynamic-drawer__shell--sticky-chrome]="entry.stickyChrome">
						<ngx-app-template-drawer *ngIf="entry.kind === 'template'" [entry]="entry" />
						<ngx-app-component-drawer *ngIf="entry.kind === 'component'" [entry]="entry" />
					</div>
				</ng-template>
			</p-drawer>
		</ng-container>
	`,
})
export class AppDrawerHostComponent implements OnInit, OnDestroy {
	entries: DrawerEntry[] = [];
	private sub?: Subscription;

	constructor(private readonly drawerService: AppDrawerService) {
	}

	ngOnInit(): void {
		this.entries = this.drawerService.getSnapshot();
		this.sub = this.drawerService.entries$.subscribe((entries) => {
			this.entries = entries;
		});
	}

	ngOnDestroy(): void {
		this.sub?.unsubscribe();
	}

	trackById(_index: number, entry: DrawerEntry): number {
		return entry.id;
	}

	drawerStyle(entry: DrawerEntry): Record<string, string> {
		const style: Record<string, string> = {
			zIndex: String(entry.zIndex),
		};
		if (entry.width) {
			style.width = entry.width;
			style.maxWidth = entry.width;
		}
		return style;
	}

	onDrawerVisibleChange(visible: boolean, entry: DrawerEntry): void {
		if (!visible && entry.closing) {
			this.drawerService.scheduleFinalize(entry.id);
		}
	}

	onDrawerHide(entry: DrawerEntry): void {
		if (!entry.closing) {
			this.drawerService.requestClose(entry.id);
		}
	}
}
